import { createActionGroup, emptyProps, props } from '@ngrx/store';
import { CallCentreStatus } from '../../http/compliance/compliance-http.models';
import { ErrorResponse } from '../../shared/shared-http.models';

export const CallCentreStatusActions = createActionGroup({
  source: 'Call Centre Status',
  events: {
    'Load Call Centre Status': emptyProps(),
  },
});

export const CallCentreStatusAPIActions = createActionGroup({
  source: 'Call Centre Status API',
  events: {
    'Loaded Call Centre Status Successfully': props<{
      callCentreStatus: CallCentreStatus;
    }>(),
    'Loaded Call Centre Status Unsuccessfully': props<{
      error: ErrorResponse;
    }>(),
  },
});
